import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { LocalVimeoPlayerComponent } from '../../../../../ui/display/media/vimeo-player.component';
import { config } from './full-screen-hero-banner.config';
import { IPageComponentFullScreenHeroBannerData } from './full-screen-hero-banner.interface';

@Component({
    selector: 'page-component-full-screen-hero-banner',
    templateUrl: './full-screen-hero-banner.html',
    styleUrls: ['./full-screen-hero-banner.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, DfImageDirective, HrefComponent, ICmsClientModule, LocalVimeoPlayerComponent, SizeClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentFullScreenHeroBannerComponent>(config)
export class PageComponentFullScreenHeroBannerComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentFullScreenHeroBannerData;
}
